import { Button } from '@mui/material';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { GUIDES } from './tours';
import { guideFor } from './guideRules';
import { openGuide } from './guideStore';
import type { Guide } from './types';

/**
 * „Przewodnik” przy pozycji na ekranie „Przełączniki funkcji” (21.10.2026):
 * otwiera panel przewodnika na pierwszym kroku tej funkcji. Bez przewodnika —
 * nic (przełącznik techniczny albo sprzed reguły przewodników).
 */
export const GuideFlagButton = ({ flagKey, guides = GUIDES }: { flagKey: string; guides?: readonly Guide[] }) => {
  const guide = guideFor(guides, flagKey);
  if (!guide) return null;
  return (
    <Button
      size="small"
      startIcon={<SchoolOutlinedIcon fontSize="small" />}
      onClick={() => openGuide(flagKey, 0)}
      data-testid={`guide-flag-button-${flagKey}`}
    >
      Przewodnik
    </Button>
  );
};
